import { Card, Typography,Grid, Box } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import logo from '../../assets/cashilogo.png'

export function Template1({ user, qrno, expdate, amount }) 
{
   return (
    <>
    <Card sx={{ p: 2,m:2,background:'linear-gradient(195deg, #fff, #fff)', color:'#000', maxWidth:'320px', width:'100%', 
      boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px', minHeight:'180px',maxHeight:'auto' }}>
        
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'start',}}>
          <img src={user?.store_info?.store_image || logo} alt="Logo" style={{ height: 30 }} />
          <Typography variant='h6' sx={{fontSize:'12px', color:'#000'}}> {qrno || 'N/A'}</Typography>
        </Box>

        <Grid container rowSpacing={2} columnSpacing={2}  sx={{ mt:2}}>
          
          <Grid size={{ xs: 8,sm:8, md: 8,}} sx={{fontStyle:'italic'}}>
            <Typography variant='h6' sx={{fontSize:'12px', color:'#000'}}> Please scan the QR Code with {user?.store_info?.cashi_app_name || "App"} 
              to claim your coupon. </Typography>
            <Typography variant='h6' sx={{fontSize:'12px', color:'#000', mt:1}}> *Terms & Conditions apply. </Typography>
            <Typography variant='h6' sx={{fontSize:'12px', color:'#000', }}> Coupon valid till {expdate || 'NA'} </Typography>
          </Grid>

          <Grid size={{ xs: 4,sm:4, md: 4,}} sx={{textAlign:'right'}} >
              <Typography sx={{backgroundColor: '#fff', px:0.7,py:0.5, textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center',}}>
                   <QRCodeCanvas value={qrno} size={80}  sx={{textAlign:'center'}} />
              </Typography>
          </Grid>

          <Typography> ₹ {amount | 'NA'} </Typography>

        </Grid>
    </Card>
    </>
  );
}

export function Template2({  user, qrno, expdate,amount }) 
{
   return (
    <>
      <Card sx={{ p: 2,m:2,background:'linear-gradient(195deg, #90bec0, #90bec0)', color:'#000000',
         boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
         maxWidth:'320px', width:'100%', minHeight:'180px' , maxHeight:'auto'}}>

          <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'start'}}>
              <img src={user?.store_info?.store_image || logo} alt="Logo" style={{ height: 30 }} />
            <Typography variant='h6' sx={{fontSize:'12px', color:'#000000'}}>  {qrno || 'N/A'}</Typography>
          </Box>

         <Grid container rowSpacing={2} columnSpacing={2}  sx={{ mt:2}}>
             <Grid size={{ xs: 8,sm:8, md: 8,}} sx={{fontStyle:'italic'}}>
              
                <Typography variant='h6' sx={{fontSize:'12px', color:'#000000'}}> Please scan the QR Code
                  with {user?.store_info?.cashi_app_name || "App"} to claim your coupon.
                </Typography>

                <Typography variant='h6' sx={{fontSize:'12px', color:'#000000', mt:1}}>  *Terms & Conditions apply. </Typography>
                <Typography variant='h6' sx={{fontSize:'12px', color:'#000000', }}>Coupon valid till {expdate || 'NA'} </Typography>
             </Grid>

             <Grid size={{ xs: 4,sm:4, md: 4,}} sx={{textAlign:'right'}} >
                <Typography sx={{backgroundColor: '#fff', px:0.7,py:0.5, textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center',}}>
                  <QRCodeCanvas value={qrno} size={80}  sx={{textAlign:'center'}} />
                </Typography>
             </Grid>

            <Typography> ₹ {amount | 'NA'} </Typography>
         </Grid>
       </Card>
    </>
  );
}

export function Template3({ user, qrno, expdate,amount }) 
{
   return (
    <>
    <Card sx={{ p: 2,m:2,background:'linear-gradient(195deg, #008080, #006241)', color:'#ffffff',
         boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
         maxWidth:'320px', width:'100%', minHeight:'180px' , maxHeight:'auto' }}>
         
         <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'start'}}>
            <img src={user?.store_info?.store_image || logo} alt="Logo" style={{ height: 30 }} />
          <Typography variant='h6' sx={{fontSize:'12px', color:'#fff'}}>  {qrno || 'N/A'}</Typography>
         </Box>

         <Grid container rowSpacing={2} columnSpacing={2}  sx={{ mt:2}}>
             
             <Grid size={{ xs: 8,sm:8, md: 8,}} sx={{fontStyle:'italic'}}>
                <Typography variant='h6' sx={{fontSize:'12px', color:'#fff'}}> Please scan the QR Code
                  with {user?.store_info?.cashi_app_name || "App"} to claim your coupon.
                </Typography>
                <Typography variant='h6' sx={{fontSize:'12px', color:'#fff', mt:1}}>  *Terms & Conditions apply.</Typography>
                <Typography variant='h6' sx={{fontSize:'12px', color:'#fff', }}> Coupon valid till  {expdate || 'NA'} </Typography>
             </Grid>

             <Grid size={{ xs: 4,sm:4, md: 4,}} sx={{textAlign:'right'}} >
               <Typography sx={{backgroundColor: '#fff', px:0.7,py:0.5, textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center',}}>
                   <QRCodeCanvas value={qrno} size={80}  sx={{textAlign:'center'}} />
              </Typography>
             </Grid>

            <Typography> ₹ {amount | 'NA'} </Typography>
         </Grid>
       </Card>
    </>
  );
}

export function Template4({ user, qrno, expdate,amount }) 
{
   return (
    <>
    <Card sx={{m:2,background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#000000',maxWidth:'220px', width:'100%',minHeight:'170px' ,
         boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px', maxHeight:'auto' }}>
         
         <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'start',backgroundColor:'#ffffff', p:1}}>
          <img src={user?.store_info?.store_image || logo} alt="Logo" style={{ height: 22 }} />
          <Typography>  ₹ {amount | 'NA'} </Typography>
         </Box>

         <Grid container rowSpacing={0} columnSpacing={1}  sx={{ mt:0,pt:1, px:1 }}>
            <Grid size={{ xs: 4,sm:4, md: 4,}} sx={{textAlign:'center'}}>
              <Typography sx={{backgroundColor: '#fff', px:0.7,py:0.5, textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center', }}>
                   <QRCodeCanvas value={qrno} size={55}  sx={{textAlign:'center'}} />
              </Typography>
            </Grid>

            <Grid size={{ xs: 8,sm:8, md: 8,}} sx={{fontStyle:'italic',textAlign:'left'}}>
              <Typography variant='h6' sx={{fontSize:'10px',  color:'#ffffff',my:1 }}> Valid upto: {expdate || 'NA'} </Typography>
              <Typography variant='h6' sx={{fontSize:'10px', color:'#ffffff'}}>  {qrno || 'N/A'}</Typography> 
            </Grid>

            <Grid size={{ xs: 12,sm:12, md: 12,}} sx={{fontStyle:'italic'}}>
              <Typography variant='h6' sx={{fontSize:'10px', color:'#ffffff',  my:0, py:0}}> Please scan the QR Code
                with <span style={{color:'#ffffff'}}> {user?.store_info?.cashi_app_name || "App"}</span> to claim your coupon.
              </Typography>
             <Typography variant='h6' sx={{fontSize:'10px', color:'#ffffff', my:0, py:0}}> *Terms & Conditions apply.</Typography>
             </Grid>

         </Grid>
       </Card>
    </>
  );
}



